import { CommonModule } from '@angular/common';
import { Component, inject, signal, viewChild } from '@angular/core';
import { DxButtonModule, DxFormComponent, DxFormModule } from 'devextreme-angular';
import type { DxFormTypes } from 'devextreme-angular/ui/form';
import { ShamShamLogoFullIcon } from 'sham-components/icons';
import { SigninSubmitRequest } from 'sham-components/shared/models/auth';
import { SigninManager } from './signin-manager';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from 'sham-components/services';

@Component({
  selector: 'app-signin',

  imports: [
    ShamShamLogoFullIcon,
    CommonModule,
    DxFormModule,
    DxButtonModule,
    TranslateModule,
  ],
  templateUrl: './signin.html',
  styleUrl: './signin.css',
})
export class SigninComponent {
  private emailFocused = false;

  readonly manager = inject(SigninManager);
  readonly language = inject(LanguageService);

  readonly formData = signal<SigninSubmitRequest>({
    email: '',
    password: '',
    rememberMe: false,
  });

  readonly loading = signal(false);
  readonly submitError = signal<string | null>(null);

  readonly form = viewChild.required(DxFormComponent);

  focusEmail(event: DxFormTypes.ContentReadyEvent): void {
    if (this.emailFocused) return;

    const editor = event.component.getEditor('email');
    if (!editor) return;

    this.emailFocused = true;
    editor.focus();
  }

  async onSubmit() {
    if (this.loading()) return;

    const validation = this.form().instance.validate();
    if (!validation.isValid) return;

    this.loading.set(true);
    this.submitError.set(null);

    await this.manager.submitForm(this.formData(), this.submitError, this.loading);
  }
  // أضف هذه الدالة داخل كلاس SigninComponent
  onLogout() {
    // مسح بيانات البائع من التخزين المحلي
    window.localStorage.removeItem('seller_id');

    // يمكنك إضافة منطق إضافي هنا مثل إعادة التوجيه لصفحة تسجيل الدخول
    // window.location.href = '/signin';

    // أو إذا كان لديك نظام Routing:
    // this.router.navigate(['/signin']);
  }
}
